<template>
  <b-card no-body class="card mb-0 mt-0 p-3">
    <h4 class="card-title">Dia da semana limite para atualização da Formalização</h4>
    <div
      class="form-group bmd-form-group"
    >
      <b-form-group>
        <b-form-radio-group
          v-model="model.limit_day_week_for_formalization"
          :options="optionsWeekend">
        </b-form-radio-group>
      </b-form-group>
    </div>
    <h4 class="card-title">Dia da semana limite para atualização do Pós Venda</h4>
    <div
      class="form-group bmd-form-group"
    >
      <b-form-group>
        <b-form-radio-group
          v-model="model.limit_day_week_for_after_sale"
          :options="optionsWeekend">
        </b-form-radio-group>
      </b-form-group>
    </div>
    <h4 class="card-title">Dia da semana para pagamento da primeira parcela</h4>
    <div
      class="form-group bmd-form-group"
    >
      <b-form-group>
        <b-form-radio-group
          v-model="model.day_week_for_payment_of_first_installment"
          :options="optionsWeekend">
        </b-form-radio-group>
      </b-form-group>
    </div>
    <span class="hide">{{ model }}</span>
  </b-card>
</template>

<script>
export default {
  computed: {
    model: function () {
      return this.$store.state.configurations.model;
    },
  },
  data() {
    return {
      optionsWeekend: [
        {
          text: 'Domingo', value: 1
        },
        {
          text: 'Segunda', value: 2
        },
        {
          text: 'Terça', value: 3
        },
        {
          text: 'Quarta', value: 4
        },
        {
          text: 'Quinta', value: 5
        },
        {
          text: 'Sexta', value: 6
        },
        {
          text: 'Sábado', value: 7
        },
        {
          text: 'Não configurado', value: ''
        },
      ]
    }
  }
};
</script>
